import { useGetMyJobsQuery } from "~/generated/graphql";
import { useJobSubscriptions } from "./useJobSubscriptions";
import { useAuth } from "~/features/common/context/AuthContext";

export function useJobListForAssignee(assigneeID: string) {
  const auth = useAuth();

  const { data, error, isLoading } = useGetMyJobsQuery(
    { userId: assigneeID },
    { enabled: !!assigneeID && auth.isLoggedIn },
  );

  useJobSubscriptions({ assigneeID });

  return {
    jobs: data?.jobs?.items ?? [],
    error,
    isLoading,
  };
}
